import { useEffect, useState, useCallback } from 'react';
import './register.component.scss';
import Button from 'react-bootstrap/Button';
import lang from '../../../assets/i18n/en.json';
import allImages from '../../../assets/images/allImages';
import Form from 'react-bootstrap/Form';
import { useNavigate } from 'react-router';
import {
  comparePasswords,
  nameValidation,
  validateNumber,
} from '../../../utils/Utils';
import { toast } from 'react-toastify';
import { toastResponse } from '../../../helper components/Toast/Toast';
import { RegisterEnterpriseClient } from '../../../Mutations/MutationsUpdated';
import { GetEnterpriseUserInviteById } from '../../../Queries/QueriesUpdated';
import { setLoaderFalse, setLoaderTrue } from '../../../Redux/loaderSlice';
import { useDispatch, useSelector } from 'react-redux';
import {useApolloClient, useMutation, useQuery } from '@apollo/client';
import loaderImage from '../../../assets/images/animation_loader.gif';
// import registerUser from './user.json';

export function Register() {
  /**
   * DECLARING STATES AND USEEFFECT
   */
  let PAGE = lang.PAGE;
  const COMMON = lang.COMMON;
  // const ERROR = lang.ERROR;

  const urlRequestId = new URLSearchParams(window.location.search).get(
    'invite_id',
  );

  const client = useApolloClient();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const loaderReducer = useSelector((state) => state.loaderReducer);

  const [passwordToggle, setPasswordToggle] = useState(false);
  const [confirmPasswordToggle, setConfirmPasswordToggle] = useState(false);

  const [userData, setUserData] = useState({
    firstName: '',
    lastName: '',
    emailId: '',
    mobileno: '',
    role: '',
    password: '',
    confirmPassword: '',
    enterpriseId: '',
    enterpriseClientId: '',
  });
  const [errors, setError] = useState({
    firstName: false,
    firstNameError: '',
    lastName: false,
    lastNameError: '',
    email: false,
    emailError: '',
    mobileno: false,
    mobilenoError: '',
    password: false,
    passwordError: '',
    confirmPasswordError: '',
    confirmPassword: false,
  });

  // todo use lazy query
  const { refetch } = useQuery(GetEnterpriseUserInviteById);

  //Assign mutaions to variable
  const [fnRegisterEnterpriseClient, { loading }] = useMutation(
    RegisterEnterpriseClient,
    {
      onCompleted: (data) => {
        // navigate("/user/login")
        toast.success(
          toastResponse('success', 'You are registered successfully.'),
        );

        navigate('/user/login');

        // setShowConfirmationPopup(true);
        // props.onHide();
        // isLoginResponse(data);
      },

      onError: ({ graphQLErrors }) => {
        toast.error(toastResponse('error', graphQLErrors[0].message));
      },
    },
  );

  const fetchInvitedClientData = useCallback(async () => {
    refetch();

    //Animated Loader true
    dispatch(setLoaderTrue());
    try {
      const { data } = await client.query({
        query: GetEnterpriseUserInviteById,
        variables: { getEnterpriseUserInviteByIdId: urlRequestId },
      });

      setUserData({
        firstName: data.getEnterpriseUserInviteById
          ? data.getEnterpriseUserInviteById.firstName
          : '',
        lastName: data.getEnterpriseUserInviteById
          ? data.getEnterpriseUserInviteById.lastName
          : '',
        emailId: data.getEnterpriseUserInviteById
          ? data.getEnterpriseUserInviteById.email
          : '',
        mobileno: data.getEnterpriseUserInviteById?.phoneNumber
          ? data.getEnterpriseUserInviteById.phoneNumber
          : '2025551234',
        role: data.getEnterpriseUserInviteById
          ? data.getEnterpriseUserInviteById.role
          : '',
        enterpriseId: data.getEnterpriseUserInviteById
          ? data.getEnterpriseUserInviteById.clientId
          : '',
        enterpriseClientId: data.getEnterpriseUserInviteById
          ? data.getEnterpriseUserInviteById.id
          : '',
      });

      //Animated Loader false
      dispatch(setLoaderFalse());
    } catch (error) {
      //Animated Loader false
      dispatch(setLoaderFalse());

      console.error('Error in fetching enterprise list', error);
    }
  }, [client, dispatch, refetch, urlRequestId]);

  useEffect(() => {
    if (urlRequestId) {
      fetchInvitedClientData();
    }
  }, [urlRequestId, fetchInvitedClientData]);

  const onSubmit = async () => {
    try {
      let data = {
        email: userData.emailId,
        firstName: userData.firstName,
        lastName: userData.lastName,
        password: userData.password,
        // phoneNumber: userData.mobileno,
        // role: userData.role,
        clientId: userData.enterpriseId,
        phones: [
          {
            phoneNumber: userData.mobileno,
            phoneType: 'MOBILE',
          },
        ],
        inviteId: urlRequestId
      };
      sessionStorage.setItem('signUpObj', JSON.stringify(data));
      if (data) {
        fnRegisterEnterpriseClient({
          variables: {
            input: data,
            // enterpriseId: userData.enterpriseId,
            // enterpriseClientId: urlRequestId,
          },
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <div
        className="animatedLoader h-100 "
        style={{
          display: loaderReducer.loader ? 'flex' : 'none',
          position: loaderReducer.loader ? 'fixed' : 'static',
        }}
      >
        <img
          alt="loader"
          loading="lazy"
          src={loaderImage}
          className="loaderImg"
        />
      </div>
      <form className="form w-100 w-lg-450  h-100" autoComplete="off">
        {/* begin::Title */}
        <div className="pb-5 pb-lg-10">
          <h3 className="login-registration-form pageTitle fw-bolder text-dark display-6 shrinkTitle">
            Registration
          </h3>
        </div>

        {/*
        <!--begin::Form group--> */}
        <div className="fv-row mb-5">
          <label className="loginRegisterBlock label text-dark" htmlFor="email">
            {PAGE.AUTH.SIGNUP.EMAIL.LABEL}
          </label>

          <Form.Control
            type="email"
            id="register_page_email"
            name="emailId"
            value={userData.emailId}
            readOnly="readonly"
            className="login-registration-form form-control form-control-lg form-control-solid "
            placeholder={PAGE.AUTH.SIGNUP.EMAIL.PLACEHOLDER}
            autoComplete="new-password"
            tabIndex="3"
            isInvalid={errors.email}
          />
          <Form.Control.Feedback type="invalid" style={{ color: 'red' }}>
            {errors.emailError}
          </Form.Control.Feedback>
        </div>

        {/*
        <!--end::Form group--> */}
        {/*
        <!--begin::Form group--> */}
        <div className="fv-row mb-5">
          <label
            className="loginRegisterBlock label text-dark"
            htmlFor="mobileno"
          >
            Mobile Number
          </label>

          <Form.Control
            type="text"
            id="mobileno"
            name="mobileno"
            maxLength={10}
            value={userData.mobileno}
            readOnly="readonly"
            className="login-registration-form form-control form-control-lg form-control-solid "
            placeholder={PAGE.AUTH.SIGNIN.USERNAME.PLACEHOLDER}
            onChange={(e) => {
              setUserData((userData) => ({
                ...userData,
                mobileno: e.target.value,
              }));
              validateNumber(e.target.value, setError);
            }}
            tabIndex="4"
            autoFocus
            autoComplete=""
            required={errors.mobileno}
          />
          <Form.Control.Feedback
            type="required"
            style={{ color: 'red', fontSize: '0.875em', marginTop: '0.25rem' }}
          >
            {errors.mobilenoError}
          </Form.Control.Feedback>
        </div>

        {/*
        <!--end::Form group--> */}
        {/*
        <!--begin::Form group--> */}
        <div className="fv-row mb-5">
          <div className="col-md-12 pe-md-2 col-12 marginBottomRegister">
            <label
              className="loginRegisterBlock label text-dark"
              htmlFor="firstName"
            >
              {PAGE.AUTH.SIGNUP.FIRSTNAME.LABEL}
            </label>

            <Form.Control
              type="text"
              id="register_page_firstName"
              name="firstName"
              className="login-registration-form form-control form-control-lg form-control-solid is"
              placeholder={PAGE.AUTH.SIGNUP.FIRSTNAME.PLACEHOLDER}
              value={userData.firstName}
              autoComplete="new-password"
              tabIndex="1"
              autoFocus
              onChange={(e) => {
                setUserData((userData) => ({
                  ...userData,
                  firstName: e.target.value,
                }));
                nameValidation(e.target.name, e.target.value, setError);
              }}
              isInvalid={errors.firstName}
            />
            <Form.Control.Feedback type="invalid" style={{ color: 'red' }}>
              {errors.firstNameError}
            </Form.Control.Feedback>
          </div>
        </div>

        <div className="fv-row mb-5">
          <div className="col-md-12 ps-md-2 col-12 ">
            <label
              className="loginRegisterBlock label text-dark"
              htmlFor="lastName"
            >
              {PAGE.AUTH.SIGNUP.LASTNAME.LABEL}
            </label>

            <Form.Control
              type="text"
              id="register_page_lastName"
              name="lastName"
              className="login-registration-form form-control form-control-lg form-control-solid "
              tabIndex="2"
              placeholder={PAGE.AUTH.SIGNUP.LASTNAME.PLACEHOLDER}
              value={userData.lastName}
              onChange={(e) => {
                setUserData((userData) => ({
                  ...userData,
                  lastName: e.target.value,
                }));
                nameValidation(e.target.name, e.target.value, setError);
              }}
              isInvalid={errors.lastName}
            />
            <Form.Control.Feedback type="invalid" style={{ color: 'red' }}>
              {errors.lastNameError}
            </Form.Control.Feedback>
          </div>
        </div>
        {/*
        <!--end::Form group--> */}

        {/*
    
            <!--begin::Form group--> */}
        <div className="fv-row mb-5 passwordField ">
          <label
            className="loginRegisterBlock label text-dark"
            htmlFor="password"
          >
            {PAGE.AUTH.SIGNUP.PASSWORD.LABEL}
          </label>
          <div className="position-relative">
            <Form.Control
              type={passwordToggle ? 'text' : 'password'}
              value={userData.password}
              id="registration_signup_password"
              style={{ paddingRight: '4rem' }}
              name="password"
              formcontrolname="password"
              placeholder={PAGE.AUTH.SIGNUP.PASSWORD.PLACEHOLDER}
              autoComplete="new-password"
              tabIndex="5"
              onChange={(e) => {
                setUserData((userData) => ({
                  ...userData,
                  password: e.target.value,
                }));
                comparePasswords(
                  'password',
                  e.target.value,
                  userData.confirmPassword,
                  setError,
                );
              }}
              required={errors.password}
              className="login-registration-form form-control form-control-lg form-control-solid "
            />

            <div className="showPasswordBlock">
              <img
                src={allImages.showPwd}
                className="container-fluid"
                style={{ display: passwordToggle ? 'block' : 'none' }}
                onClick={(e) => {
                  setPasswordToggle((passwordToggle) => !passwordToggle);
                }}
                alt="show_password_icon"
              />
              <img
                src={allImages.hidePwd}
                className="container-fluid"
                style={{ display: !passwordToggle ? 'block' : 'none' }}
                onClick={(e) =>
                  setPasswordToggle((passwordToggle) => !passwordToggle)
                }
                alt="hide_password_icon"
              />
            </div>
          </div>
          <Form.Control.Feedback
            type="required"
            style={{ color: 'red', fontSize: '0.875em', marginTop: '0.25rem' }}
          >
            {errors.passwordError}
          </Form.Control.Feedback>
        </div>
        {/*
        <!--end::Form group--> */}

        {/*
        <!--begin::Form group--> */}
        <div className="fv-row mb-5 passwordField">
          <label
            className="loginRegisterBlock label text-dark"
            htmlFor="password"
          >
            {PAGE.AUTH.SIGNUP.CONFIRMPASSWORD.LABEL}
          </label>
          <div className="position-relative">
            <Form.Control
              required={errors.confirmPassword}
              value={userData.confirmPassword}
              type={confirmPasswordToggle ? 'text' : 'password'}
              id="registration_page_confirmPassword"
              name="confirmPassword"
              formcontrolname="password"
              style={{ paddingRight: '4rem' }}
              className="login-registration-form form-control form-control-lg form-control-solid "
              placeholder={PAGE.AUTH.SIGNUP.CONFIRMPASSWORD.PLACEHOLDER}
              autoComplete="new-password"
              tabIndex="6"
              onChange={(e) => {
                setUserData((userData) => ({
                  ...userData,
                  confirmPassword: e.target.value,
                }));
                comparePasswords(
                  'confirmpassword',
                  e.target.value,
                  userData.password,
                  setError,
                );
              }}
            />
            <div className="showConfirmPasswordBlock">
              <img
                src={allImages.showPwd}
                className="container-fluid"
                style={{ display: confirmPasswordToggle ? 'block' : 'none' }}
                onClick={(e) => {
                  setConfirmPasswordToggle(
                    (confirmPasswordToggle) => !confirmPasswordToggle,
                  );
                }}
                alt="show_password_icon"
              />
              <img
                src={allImages.hidePwd}
                className="container-fluid"
                style={{ display: !confirmPasswordToggle ? 'block' : 'none' }}
                onClick={(e) =>
                  setConfirmPasswordToggle(
                    (confirmPasswordToggle) => !confirmPasswordToggle,
                  )
                }
                alt="hide-password_icon"
              />
            </div>
          </div>
          <Form.Control.Feedback
            type="required"
            style={{ color: 'red', fontSize: '0.875em', marginTop: '0.25rem' }}
          >
            {errors.confirmPasswordError}
          </Form.Control.Feedback>
        </div>
        {/*
        <!--end::Form group--> */}

        {/*
        <!--begin::Action--> */}
        <Button
          className="theme btn btn-primary me-4"
          disabled={
            !(
              userData.firstName &&
              userData.emailId &&
              userData.mobileno &&
              userData.lastName &&
              userData.password &&
              userData.confirmPassword &&
              !errors.firstName &&
              !errors.lastName &&
              !errors.mobileno &&
              !errors.confirmPassword &&
              !errors.password &&
              !errors.email
            )
          }
          onClick={(e) => {
            e.preventDefault();
            onSubmit();
          }}
        >
          {PAGE.AUTH.SIGNUP.SUBMIT_BUTTON.LABEL}{' '}
          {loading && (
            <i className="spinner-grow spinner-grow-sm ms-3" role="status" />
          )}
        </Button>

        <Button
          className=" btn btn-secondary border-primary me-3"
          onClick={() => navigate('/user/login')}
        >
          {COMMON.LABEL.CANCEL}
        </Button>

        {/*
        <!--end::Action--> */}
      </form>
    </>
  );
}
